<div class="full-view">
    <elab-magic-login-form></elab-magic-login-form>
</div>
